/**
 * Google Calendar Data Provider
 *
 * Provides only the React Query context and persistence for Google Calendar data.
 * This component can be placed above UserProvider since it doesn't need authenticated user data.
 * The actual queries are handled by individual hooks that use this context.
 */

import React from 'react'
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import {
  googleCalendarDataContext,
  googleCalendarDataQueryClient,
  localStoragePersister,
  googleCalendarDataMaxAge,
  validateToken,
} from './persister'

export function GoogleCalendarDataProvider({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <PersistQueryClientProvider
      context={googleCalendarDataContext}
      client={googleCalendarDataQueryClient}
      persistOptions={{
        persister: localStoragePersister,
        maxAge: googleCalendarDataMaxAge,
      }}
      onSuccess={validateToken}
    >
      {children}
    </PersistQueryClientProvider>
  )
}
